import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKey96 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3385_184034)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M70.75 52.1176C75.5938 49.2059 78.5 44.3529 78.5 38.5294C78.5 29.7941 71.7188 23 63 23C54.2812 23 47.5 29.7941 47.5 38.5294C47.5 43.3824 49.9219 47.75 53.3125 50.6618V79.2941L63 89L72.6875 79.2941L66.875 73.4706L72.6875 67.6471L66.875 61.8235L70.75 57.9412V52.1176Z",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M64.5 22.7098L61.62 19.7561C56.34 14.8333 48.18 14.8333 42.42 19.2638C38.1 23.2021 36.18 28.6172 36.66 33.5401L35.7 34.5246L16.5 54.216V68H29.94V60.1234H37.62V52.2469H43.38L47.7 48.3086L49.14 46.3395",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.5 17C48.431 11 53.7414 7 60.0172 7C68.2241 7 74.5 13.5 74.5 22C74.5 27.5 71.6034 32.5 67.2586 35",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 63.5,
				cy: 36,
				r: 5,
				stroke: "black",
				strokeWidth: 4
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3385_184034",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgKey96;
